/** The page sizes a table offers, smallest first. */
export const PageSizes: readonly number[] = [10, 25, 50, 100];
